<!--已出账单 账单明细-->
<template>
  <div class="billed-detail-container">
    <div class="header">
      <span class="col-left">
        <span
          class="title"
        >{{ currentBilledInfo.cutMonth | getMonth }}月账单</span>
        <span
          v-if="currentBilledInfo.subAccountId"
          class="sub-title"
        >子账号钱包收款</span>
      </span>
      <div v-if="currentBilledInfo.receivableStatusDesc">
        {{ currentBilledInfo.receivableStatusDesc }}
      </div>
      <BillStatus
        v-else
        :status="currentBilledInfo.billStatus"
      />
    </div>
    <div class="panel-box">
      <div class="panel-head">
        <span class="head-left">
          <span class="head-title">我的分成</span>
        </span>
        <span
          class="head-right"
        >合计：{{ currentBilledInfo.totalDivideAmount | formatAmount }}元</span>
      </div>
      <div class="menu-list">
        <div
          v-if="currentBilledInfo.rentDivideAmount!=null"
          class="menu-item border1px-bottom"
          :data-bid="$BID.BILL_DETAIL_RENT_BILL"
          :data-cid="cid"
          @click="gotoPage('monthBillDetail', 0)"
        >
          <span class="item-label">
            <span>租宝分成</span><br />
            <span
              v-if="currentBilledInfo.toDeductAmount"
              class="sub-label"
            >
              其中{{ currentBilledInfo.toDeductAmount | formatAmount }}元参与循环预付款不打款
            </span>
          </span>
          <span>
            <span style="position:relative">{{ currentBilledInfo.rentDivideAmount | formatAmount }}元
              <i
                class="right-arrow"
                style="right:-13px"
              ></i>
            </span>
          </span>
        </div>
        <div
          v-if="currentBilledInfo.saleDivideAmount!=null"
          class="menu-item border1px-bottom"
          :data-bid="$BID.BILL_DETAIL_SALE_BILL"
          :data-cid="cid"
          @click="gotoPage('monthBillDetail', 1)"
        >
          <span class="item-label">售宝分成</span>
          <span>{{ currentBilledInfo.saleDivideAmount | formatAmount }}元
            <i class="right-arrow"></i>
          </span>
        </div>
        <div
          v-if="currentBilledInfo.bonusAmount!=null && accountType===3"
          class="menu-item border1px-bottom"
          data-bid=""
          :data-cid="cid"
          @click="gotoPage('bonusAmount')"
        >
          <span class="item-label">激励账单</span>
          <span>{{ currentBilledInfo.bonusAmount | formatAmount }}元
            <i class="right-arrow"></i>
          </span>
        </div>
        <div
          v-if="currentBilledInfo.agentAgreementBillAmount"
          class="menu-item border1px-bottom"
          :data-bid="$BID.BILL_DETAIL_SALE_BILL"
          :data-cid="cid"
          @click="gotoAgentActivity"
        >
          <span class="item-label">活动账单</span>
          <span>{{ currentBilledInfo.agentAgreementBillAmount | formatAmount }}元
            <i class="right-arrow"></i>
          </span>
        </div>
        <div
          v-if="currentBilledInfo.overChargeAmount<0"
          class="menu-item border1px-bottom"
          @click="gotoPage('amortize')"
        >
          <span class="item-label">多宝摊销</span>
          <span>{{ currentBilledInfo.overChargeAmount | formatAmount }}元
            <i class="right-arrow"></i>
          </span>
        </div>
        <div
          v-if="currentBilledInfo.partnerRebateAmount !== undefined && currentBilledInfo.partnerRebateAmount !== null"
          class="menu-item border1px-bottom"
          @click="gotoPage('cashback')"
        >
          <span class="item-label">合作返点</span>
          <span>{{ currentBilledInfo.partnerRebateAmount | formatAmount }}元
            <i class="right-arrow"></i>
          </span>
        </div>
      </div>
    </div>
    <div
      v-if="showOtherPanel"
      class="panel-box"
    >
      <div class="panel-head">
        <span class="head-left">
          <span class="head-title">其他款项</span>
        </span>
        <span
          class="head-right"
        >合计：{{ currentBilledInfo.totalOtherAmount | formatAmount }}元</span>
      </div>
      <div class="menu-list">
        <template
          v-for="item in currentBilledInfo.otherBillInfo"
        >
          <div
            v-if="item.amount !== 0"
            :key="item.subjectType"
            class="menu-item border1px-bottom"
            @click="() => {item.haveDetail && gotoPage('otherExpenseDetail', item.subjectType, item.amount);}"
          >
            <span class="item-label">{{ item.subjectName }}</span>
            <span>
              <span>{{ item.amount | formatAmount }}元
                <i
                  v-if="item.haveDetail"
                  class="right-arrow"
                ></i>
              </span>
            </span>
          </div>
        </template>
      </div>
    </div>
    <div
      v-if="currentBilledInfo.prepaidAmount !== undefined"
      class="panel-box"
    >
      <div class="panel-head">
        <span class="head-left">
          <span class="head-title">预付款活动（不参与付款）</span>
        </span>
        <span
          class="head-right"
        >合计：{{ currentBilledInfo.prepaidAmount | formatAmount }}元</span>
      </div>
      <div class="menu-list"></div>
    </div>
    <div class="other-detail">
      <div
        v-if="currentBilledInfo.actualAmount >= 0"
        class="row"
      >
        <span class="col-left">实收金额：</span>
        <span class="col-right">
          {{ currentBilledInfo.actualAmount | formatAmount }}元
          <span
            v-if="currentBilledInfo.agentTaxShow === 1"
            class="invoice-link"
            @click="onClickInvoiceInfo"
          >点击查看开票信息</span>
        </span>
      </div>
      <div
        v-else
        class="row arrow-row"
        @click="onClickReceivableHistory"
      >
        <span>本月无收益（{{ currentBilledInfo.actualAmount | formatAmount }}元将在未来账单中抵扣）</span>
        <van-icon name="arrow" />
      </div>
      <div class="row">
        <span class="col-left">账单单号：</span>
        <span class="col-right">{{ currentBilledInfo.billNo }}</span>
      </div>
      <div
        v-if="currentBilledInfo.walletId"
        class="row"
      >
        <span class="col-left">钱包id：</span>
        <span class="col-right">{{ currentBilledInfo.walletId }}</span>
      </div>
      <template v-if="!isAgentUser">
        <div class="row">
          <span class="col-left">提交账号：</span>
          <span class="col-right">{{ currentBilledInfo.confirmAccountId || '-' }}</span>
        </div>
        <div class="row">
          <span class="col-left">提交时间：</span>
          <span class="col-right">{{ currentBilledInfo.confirmTime || '-' }}</span>
        </div>
      </template>
      <div
        v-if="currentBilledInfo.payFailReason"
        class="row"
      >
        <span class="col-left">失败原因：</span>
        <span class="col-right">{{ currentBilledInfo.payFailReason }}</span>
      </div>
      <div
        v-if="currentBilledInfo.taxAmount >=0"
        class="panel-box"
      >
        <div class="panel-head">
          <span class="head-left">
            <span class="head-title">税费补款详情</span>
          </span>
        </div>
        <div class="other-detail">
          <div class="row">
            <span class="col-left">补税金额：</span>
            <span class="col-right">{{ currentBilledInfo.taxAmount |formatAmount }}元</span>
          </div>
          <div class="row">
            <span class="col-left">钱包id：</span>
            <span class="col-right">{{ currentBilledInfo.taxWalletId }}</span>
          </div>
          <div class="row">
            <span class="col-left">付款时间：</span>
            <span class="col-right">{{ currentBilledInfo.taxTime|| '-' }}</span>
          </div>
        </div>
      </div>
      <template v-if="!isAgentUser">
        <div class="row">
          本月收入可在次月15号（含）之后在首页确认并提现。
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BillStatus from '@/components/BillStatus';
import { getMonth } from '@/util/filter';
import tracker from '@/util/tracker';
import { ACTIVITY_BILL_TYPE } from '@/constants/bill';

export default {
  name: 'BilledDetail',
  components: {
    BillStatus,
  },
  filters: {
    getMonth,
  },
  data() {
    return {
      cid: this.$BID.BilledDetail,
    };
  },
  computed: {
    ...mapState(['accountType']),
    ...mapState('billModule', ['billedList', 'currentBilledInfo']),
    ...mapGetters(['isAgentUser']),
    showOtherPanel() {
      const { otherBillInfo } = this.currentBilledInfo;
      return otherBillInfo && otherBillInfo.length > 0;
    },
  },
  mounted() {
    const arr = this.currentBilledInfo.otherBillInfo || [];
    for (let index = 0; index < arr.length; index++) {
      const info = arr[index];
      tracker.sendModuleView(this.$BID.BILL_DETAIL_OTHER_MV, { bill_type: info.subjectType }, { cid: this.cid });
    }
  },
  methods: {
    gotoPage(page, type, amount) {
      if (page === 'monthBillDetail') {
        // 租宝分成 或者 售宝分成
        this.$router.push({
          name: 'MonthBillList',
          query: {
            from: 'billed',
            type,
          },
        });
      } else if (page === 'otherExpenseDetail') {
        tracker.sendModuleClick(this.$BID.BILL_DETAIL_OTHER_MC, { bill_type: type }, { cid: this.cid });
        // 其他款项-其他扣减
        if (type === 7) {
          this.$router.push({
            name: 'OffsetDetail',
          });
        // 其他款项-商家券账单
        } else if (type === 9) {
          this.$router.push({
            name: 'CouponBill',
          });
        // 其他款项-丢宝找回补款
        } else if (type === 10) {
          this.$router.push({
            name: 'Inventory',
            query: {
              from: 'billed',
            },
          });
          // 其他款项-电力税补款
        } else if (type === 11) {
          this.$router.push({
            name: 'TaxRecharge',
            query: { amount },
          });
        } else if (type === 14) {
          const { cutMonth } = this.currentBilledInfo;
          this.$router.push({
            name: 'CashReward',
            query: { cutMonth, amount },
          });
        } else if (type === 16) {
          // 其他款项-设备运营服务费返还
          const { cutMonth } = this.currentBilledInfo;
          this.$router.push({
            name: 'ServiceFeeRefundDetail',
            query: { cutMonth, amount },
          });
        } else {
          // 其他款项
          const { settleUnitId, cutMonth, settleUnitMode } = this.currentBilledInfo;
          this.$router.push({
            name: 'OtherExpenseDetail',
            query: {
              type, settleUnitId, cutMonth, settleUnitMode,
            },
          });
        }
      } else if (page === 'adjustmentDetail') {
        this.$router.push({
          name: 'AdjustmentDetail',
        });
      } else if (page === 'amortize') {
        this.$router.push({
          name: 'Amortize',
          query: {
            from: 'billed',
          },
        });
      } else if (page === 'cashback') {
        this.$router.push({
          name: 'Cashback',
        });
      } else if (page === 'bonusAmount') {
        this.$router.push({
          name: 'BonusAmount',
          query: {
            bonusAmount: this.currentBilledInfo.bonusAmount,
            from: 'billed',
          },
        });
      }
    },
    /**
     * 抵扣记录
     */
    onClickReceivableHistory() {
      tracker.sendModuleClick(this.$BID.BILL_DETAIL_RECEIVALBE, null, { cid: this.cid });
      const { billNo } = this.currentBilledInfo;
      this.$router.push({
        name: 'ReceivableHistory',
        query: { billNo },
      });
    },
    gotoAgentActivity() {
      this.$router.push({
        name: 'AgentActivityBillList',
        query: {
          billType: ACTIVITY_BILL_TYPE.BILLED,
          billMonth: this.currentBilledInfo.cutMonth,
          amount: this.currentBilledInfo.agentAgreementBillAmount,
        },
      });
    },
    /**
     * 查看开票信息
     */
    onClickInvoiceInfo() {
      const { agentCustomerId } = this.currentBilledInfo;
      // 跳转到开票信息页面，根据 agentCustomerId 查询开票信息
      this.$router.push({
        name: 'AgentInvoiceInfo',
        query: {
          agentCustomerId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/page/bill.scss";
.billed-detail-container {
  .header {
    .title {
      font-weight: 600;
      font-size: 36px;
      color: rgba(0, 0, 0, 0.84);
    }
    .sub-title {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.42);
      margin-left: 16px;
    }
  }
  .head-right {
    font-size: 32px;
    font-weight: bold;
  }
  .menu-list {
    margin: 0.18rem 0;
    padding-left: 0;
    .menu-item {
      position: relative;
      padding: 20px 26px 20px 0;
      font-size: 26px;
      text-align: left;
      .item-label {
        .sub-label {
          font-size: 24px;
          color: rgba(0, 0, 0, 0.42);
        }
      }
      .right-arrow {
        right: 0;
      }
    }
  }
  .other-detail {
    margin: 18px 18px 9px;
    padding: 8px 36px;
    .row {
      display: flex;
      justify-content: start;
      align-items: flex-start;
      text-align: left;
      margin: 16px 0;
      color: rgba(0, 0, 0, 0.5);
      .col-left {
        width: 130px;
      }
      .col-right {
        flex: 1;
        color: rgba(0, 0, 0, 0.84);
      }
    }
    .arrow-row {
      justify-content: space-between;
      align-items: center;
    }
    .invoice-link {
      display: inline-block;
      margin-left: 12px;
      color: #47cb14;
      font-size: 24px;
      text-decoration: underline;
      cursor: pointer;
    }
  }

}
</style>
